import ApiService from 'services/ApiService';
import { MESSAGES } from 'constants/Constants';

import { addNotification } from 'store/notificationModule/actions';

import { extractError } from '../../utils/functions';
import AnalyticsCore from '../../components/AnalyticsHandler/AnalyticsCore';

/*
 Name Convention for redux action creator

 Async GET calls:
 FETCH_*type*_*state*

 Async POST calls:
 CREATE_*type*_*state*

 Async PUT calls:
 UPDATE_*type*_*state*

 Usual each state should have
 *_WAITING
 *_FAILED
 *_COMPLETED
 */

const ACTION_PREFIX = 'app';
export const AppActionTypes = {
  SEND_EVENT: `${ACTION_PREFIX}/SEND_EVENT`,
  INC_SEARCH_LOADER: `${ACTION_PREFIX}/INC_SEARCH_LOADER`,

  CREATE_STRIPE_TOKEN_IN_PROGRESS: `${ACTION_PREFIX}/CREATE_STRIPE_TOKEN_IN_PROGRESS`,
  CREATE_STRIPE_TOKEN_IN_FAILED: `${ACTION_PREFIX}/CREATE_STRIPE_TOKEN_IN_FAILED`,

  FETCH_ORGANIZATION_SETTINGS_WAITING: `${ACTION_PREFIX}/FETCH_ORGANIZATION_SETTINGS_WAITING`,
  FETCH_ORGANIZATION_SETTINGS_COMPLETED: `${ACTION_PREFIX}/FETCH_ORGANIZATION_SETTINGS_COMPLETED`,
  FETCH_ORGANIZATION_SETTINGS_FAILED: `${ACTION_PREFIX}/FETCH_ORGANIZATION_SETTINGS_FAILED`,

  UPDATE_ORGANIZATION_SETTINGS_WAITING: `${ACTION_PREFIX}/UPDATE_ORGANIZATION_SETTINGS_WAITING`,
  UPDATE_ORGANIZATION_SETTINGS_COMPLETED: `${ACTION_PREFIX}/UPDATE_ORGANIZATION_SETTINGS_COMPLETED`,
  UPDATE_ORGANIZATION_SETTINGS_FAILED: `${ACTION_PREFIX}/UPDATE_ORGANIZATION_SETTINGS_FAILED`,

  APPLY_DISCOUNT_WAITING: `${ACTION_PREFIX}/APPLY_DISCOUNT_WAITING`,
  APPLY_DISCOUNT_COMPLETED: `${ACTION_PREFIX}/APPLY_DISCOUNT_COMPLETED`,
  APPLY_DISCOUNT_FAILED: `${ACTION_PREFIX}/APPLY_DISCOUNT_FAILED`,

  FETCH_DISCOUNTS_WAITING: `${ACTION_PREFIX}/FETCH_DISCOUNTS_WAITING`,
  FETCH_DISCOUNTS_COMPLETED: `${ACTION_PREFIX}/FETCH_DISCOUNTS_COMPLETED`,

  ADD_MEMBER: `${ACTION_PREFIX}/ADD_MEMBER`,
  ADD_PENDING_MEMBER: `${ACTION_PREFIX}/ADD_PENDING_MEMBER`,

  FETCH_PAYMENT_METHOD_WAITING: `${ACTION_PREFIX}/FETCH_PAYMENT_METHOD_WAITING`,
  FETCH_PAYMENT_METHOD_FAILED: `${ACTION_PREFIX}/FETCH_PAYMENT_METHOD_FAILED`,
  FETCH_PAYMENT_METHOD_COMPLETED: `${ACTION_PREFIX}/FETCH_PAYMENT_METHOD_COMPLETED`,

  FETCH_ORGANIZATION_METHOD_WAITING: `${ACTION_PREFIX}/FETCH_ORGANIZATION_METHOD_WAITING`,
  FETCH_ORGANIZATION_METHOD_FAILED: `${ACTION_PREFIX}/FETCH_ORGANIZATION_METHOD_FAILED`,
  FETCH_ORGANIZATION_METHOD_COMPLETED: `${ACTION_PREFIX}/FETCH_ORGANIZATION_METHOD_COMPLETED`,

  FETCH_PENDING_ORGANIZATION_USERS_WAITING: `${ACTION_PREFIX}/FETCH_PENDING_ORGANIZATION_USERS_WAITING`,
  FETCH_PENDING_ORGANIZATION_USERS_COMPLETED: `${ACTION_PREFIX}/FETCH_PENDING_ORGANIZATION_USERS_COMPLETED`,
  FETCH_PENDING_ORGANIZATION_USERS_FAILED: `${ACTION_PREFIX}/FETCH_PENDING_ORGANIZATION_USERS_FAILED`,

  CREATE_PAYMENT_WAITING: `${ACTION_PREFIX}/CREATE_PAYMENT_WAITING`,
  CREATE_PAYMENT_FAILED: `${ACTION_PREFIX}/CREATE_PAYMENT_FAILED`,
  CREATE_PAYMENT_COMPLETED: `${ACTION_PREFIX}/CREATE_PAYMENT_COMPLETED`,

  CREATE_ORGANIZATION_COMPLETED: `${ACTION_PREFIX}/CREATE_ORGANIZATION_COMPLETED`,
  CREATE_ORGANIZATION_WAITING: `${ACTION_PREFIX}/CREATE_ORGANIZATION_WAITING`,
  CREATE_ORGANIZATION_FAILED: `${ACTION_PREFIX}/CREATE_ORGANIZATION_FAILED`,

  FETCH_ORGANIZATION_USERS_WAITING: `${ACTION_PREFIX}/FETCH_ORGANIZATION_USERS_WAITING`,
  FETCH_ORGANIZATION_USERS_COMPLETED: `${ACTION_PREFIX}/FETCH_ORGANIZATION_USERS_COMPLETED`,
  FETCH_ORGANIZATION_USERS_FAILED: `${ACTION_PREFIX}/FETCH_ORGANIZATION_USERS_FAILED`,

  SET_PRE_PROMO: `${ACTION_PREFIX}/SET_PRE_PROMO`,
  SET_PRE_VOUCHER: `${ACTION_PREFIX}/SET_PRE_VOUCHER`,

  OPEN_PRINT_MODAL: `${ACTION_PREFIX}/OPEN_PRINT_MODAL`,
  CLOSE_PRINT_MODAL: `${ACTION_PREFIX}/CLOSE_PRINT_MODAL`,
  SELECT_PRINT_OPTION: `${ACTION_PREFIX}/SELECT_PRINT_OPTION`,
  PERFORM_PRINT_REQUEST: `${ACTION_PREFIX}/PERFORM_PRINT_REQUEST`,
  PERFORM_PRINT_SUCCESS: `${ACTION_PREFIX}/PERFORM_PRINT_SUCCESS`,

  REMOVE_PROMO_CODE: `${ACTION_PREFIX}/REMOVE_PROMO_CODE`,
  UPDATE_PAYMENT: `${ACTION_PREFIX}/UPDATE_PAYMENT`,

  STARTUP: `${ACTION_PREFIX}/STARTUP`,
  STARTUP_COMPLETED: `${ACTION_PREFIX}/STARTUP_COMPLETED`,

  DISABLE_NEW_VERSION: `${ACTION_PREFIX}/DISABLE_NEW_VERSION`,
};

export function disableNewVersion() {
  return {
    type: AppActionTypes.DISABLE_NEW_VERSION,
  };
}

export function openPrintModal() {
  return {
    type: AppActionTypes.OPEN_PRINT_MODAL,
  };
}
export function closePrintModal() {
  return {
    type: AppActionTypes.CLOSE_PRINT_MODAL,
  };
}

export function selectPrintOption(printOption) {
  return {
    type: AppActionTypes.SELECT_PRINT_OPTION,
    payload: printOption,
  };
}

export function performPrintRequest() {
  return {
    type: AppActionTypes.PERFORM_PRINT_REQUEST,
  };
}

export function performPrintSuccess() {
  return {
    type: AppActionTypes.PERFORM_PRINT_SUCCESS,
  };
}

export function setSearchProgress(progress) {
  return {
    type: AppActionTypes.INC_SEARCH_LOADER,
    payload: progress,
  };
}

export function startUp() {
  return {
    type: AppActionTypes.STARTUP,
  };
}

export function startUpCompleted() {
  return {
    type: AppActionTypes.STARTUP_COMPLETED,
  };
}

export function createStripeTokenInProgress() {
  return {
    type: AppActionTypes.CREATE_STRIPE_TOKEN_IN_PROGRESS,
    payload: {
      msg: MESSAGES.CREATE_STRIPE_TOKEN_IN_PROGRESS,
    },
  };
}

export function createStripeTokenFailed(error) {
  return {
    type: AppActionTypes.CREATE_STRIPE_TOKEN_IN_FAILED,
    payload: {
      msg: error || MESSAGES.CREATE_STRIPE_TOKEN_IN_FAILED,
    },
  };
}

export function fetchOrganizationSettingsInProgress() {
  return {
    type: AppActionTypes.FETCH_ORGANIZATION_SETTINGS_WAITING,
    payload: {
      msg: MESSAGES.FETCH_ORGANIZATION_SETTINGS_WAITING,
    },
  };
}

export function fetchOrganizationSettingsCompleted(settings) {
  return {
    type: AppActionTypes.FETCH_ORGANIZATION_SETTINGS_COMPLETED,
    payload: {
      settings,
    },
  };
}

export function fetchOrganizationSettingsFailed(error) {
  return {
    type: AppActionTypes.FETCH_ORGANIZATION_SETTINGS_FAILED,
    payload: {
      error,
    },
  };
}

export function updateOrganizationSettingsInProgress() {
  return {
    type: AppActionTypes.UPDATE_ORGANIZATION_SETTINGS_WAITING,
    payload: {
      msg: MESSAGES.UPDATE_ORGANIZATION_SETTINGS_WAITING,
    },
  };
}

export function updateOrganizationSettingsCompleted(settings, deleteLogs) {
  return {
    type: AppActionTypes.UPDATE_ORGANIZATION_SETTINGS_COMPLETED,
    payload: {
      settings,
      deleteLogs,
    },
  };
}

export function updateOrganizationSettingsFailed(error) {
  return {
    type: AppActionTypes.UPDATE_ORGANIZATION_SETTINGS_FAILED,
    payload: {
      error,
    },
  };
}

export function applyDiscountInProgress() {
  return {
    type: AppActionTypes.APPLY_DISCOUNT_WAITING,
    payload: {
      msg: MESSAGES.APPLY_DISCOUNT_WAITING,
    },
  };
}

export function applyDiscountCompleted(discount) {
  return {
    type: AppActionTypes.APPLY_DISCOUNT_COMPLETED,
    payload: {
      discount,
    },
  };
}

export function applyDiscountFailed(error) {
  return {
    type: AppActionTypes.APPLY_DISCOUNT_FAILED,
    payload: {
      error,
    },
  };
}

export function fetchDiscountsInProgress() {
  return {
    type: AppActionTypes.FETCH_DISCOUNTS_WAITING,
  };
}

export function fetchDiscountsCompleted(discounts) {
  return {
    type: AppActionTypes.FETCH_DISCOUNTS_COMPLETED,
    payload: {
      discounts,
    },
  };
}

export function addMember(user) {
  return {
    type: AppActionTypes.ADD_MEMBER,
    payload: {
      user,
    },
  };
}

export function addPendingMember(user) {
  return {
    type: AppActionTypes.ADD_PENDING_MEMBER,
    payload: {
      user,
    },
  };
}

export function fetchPaymentMethodInProgress() {
  return {
    type: AppActionTypes.FETCH_PAYMENT_METHOD_WAITING,
  };
}

export function fetchPaymentMethodFailed(msgError) {
  return {
    type: AppActionTypes.FETCH_PAYMENT_METHOD_FAILED,
    payload: {
      status: msgError || MESSAGES.CREATE_PAYMENT_FAILED,
    },
  };
}

export function fetchPaymentMethodCompleted(paymentMethod) {
  return {
    type: AppActionTypes.FETCH_PAYMENT_METHOD_COMPLETED,
    payload: {
      paymentMethod,
    },
  };
}

export function fetchOrganizationInProgress() {
  return {
    type: AppActionTypes.FETCH_ORGANIZATION_METHOD_WAITING,
  };
}

export function fetchOrganizationFailed(msgError) {
  return {
    type: AppActionTypes.FETCH_ORGANIZATION_METHOD_FAILED,
    payload: {
      status: msgError || MESSAGES.CREATE_ORGANIZATION_FAILED,
    },
  };
}

export function fetchOrganizationCompleted(organization) {
  return {
    type: AppActionTypes.FETCH_ORGANIZATION_METHOD_COMPLETED,
    payload: {
      organization,
    },
  };
}

export function createPaymentInProgress() {
  return {
    type: AppActionTypes.CREATE_PAYMENT_WAITING,
    payload: {
      status: MESSAGES.CREATE_PAYMENT_WAITING,
    },
  };
}

export function createPaymentFailed(msgError) {
  return {
    type: AppActionTypes.CREATE_PAYMENT_FAILED,
    payload: {
      status: msgError || MESSAGES.CREATE_PAYMENT_FAILED,
    },
  };
}

export function createPaymentCompleted(paymentMethod, eventData = null) {
  if (eventData) {
    const specificEventData = { ...eventData };
    specificEventData.eventName = `${eventData.eventName}_Completed`;
    AnalyticsCore.sendEvent(specificEventData);
  }
  return {
    type: AppActionTypes.CREATE_PAYMENT_COMPLETED,
    payload: {
      paymentMethod,
    },
  };
}

export function createOrganizationCompleted(organization, eventData = null) {
  if (eventData) {
    const specificEventData = { ...eventData };
    specificEventData.eventName = `${eventData.eventName}_Completed`;
    AnalyticsCore.sendEvent(specificEventData);
  }
  return {
    type: AppActionTypes.CREATE_ORGANIZATION_COMPLETED,
    payload: {
      organization,
    },
  };
}

export function createOrganizationInProgress() {
  return {
    type: AppActionTypes.CREATE_ORGANIZATION_WAITING,
    payload: {
      status: MESSAGES.CREATE_ORGANIZATION_WAITING,
    },
  };
}

export function createOrganizationFailed(msgError, serverErrorByField = null, eventData = null) {
  if (eventData) {
    const specificEventData = { ...eventData };
    specificEventData.eventName = `${eventData.eventName}_Failed`;
    specificEventData.eventLabel = msgError || MESSAGES.CREATE_ORGANIZATION_FAILED;
    AnalyticsCore.sendEvent(specificEventData);
  }
  return {
    type: AppActionTypes.CREATE_ORGANIZATION_FAILED,
    payload: {
      status: msgError || MESSAGES.CREATE_ORGANIZATION_FAILED,
      serverErrorByField,
    },
  };
}

export function fetchOrganizationPendingMembersInProgress() {
  return {
    type: AppActionTypes.FETCH_PENDING_ORGANIZATION_USERS_WAITING,
  };
}

export function fetchOrganizationPendingMembersCompleted(members) {
  return {
    type: AppActionTypes.FETCH_PENDING_ORGANIZATION_USERS_COMPLETED,
    payload: {
      members,
    },
  };
}

export function fetchOrganizationPendingMembersFailed(msgError) {
  return {
    type: AppActionTypes.FETCH_PENDING_ORGANIZATION_USERS_FAILED,
    payload: {
      status: msgError || MESSAGES.FETCH_ORGANIZATION_USERS_FAILED,
    },
  };
}

export function fetchOrganizationMembersInProgress() {
  return {
    type: AppActionTypes.FETCH_ORGANIZATION_USERS_WAITING,
  };
}

export function fetchOrganizationMembersCompleted(members) {
  return {
    type: AppActionTypes.FETCH_ORGANIZATION_USERS_COMPLETED,
    payload: {
      members,
    },
  };
}

export function fetchOrganizationMembersFailed(msgError) {
  return {
    type: AppActionTypes.FETCH_ORGANIZATION_USERS_FAILED,
    payload: {
      status: msgError || MESSAGES.FETCH_ORGANIZATION_USERS_FAILED,
    },
  };
}

export function setPrePromo(promoCode) {
  return {
    type: AppActionTypes.SET_PRE_PROMO,
    payload: {
      promoCode,
    },
  };
}

export function setPreVoucher(voucher) {
  return {
    type: AppActionTypes.SET_PRE_VOUCHER,
    payload: {
      voucher,
    },
  };
}

export function removePrePromoCode() {
  return {
    type: AppActionTypes.REMOVE_PROMO_CODE,
  };
}

export function sendEvent(event) {
  return {
    type: AppActionTypes.SEND_EVENT,
    payload: event,
  };
}

export const AppActions = {
  createStripeTokenInProgress,
  createStripeTokenFailed,
  fetchOrganizationSettingsInProgress,
  fetchOrganizationSettingsCompleted,
  fetchOrganizationSettingsFailed,
  updateOrganizationSettingsInProgress,
  updateOrganizationSettingsCompleted,
  updateOrganizationSettingsFailed,
  applyDiscountInProgress,
  applyDiscountCompleted,
  applyDiscountFailed,
  fetchDiscountsInProgress,
  fetchDiscountsCompleted,
  addMember,
  addPendingMember,
  fetchPaymentMethodInProgress,
  fetchPaymentMethodFailed,
  fetchPaymentMethodCompleted,
  fetchOrganizationInProgress,
  fetchOrganizationFailed,
  fetchOrganizationCompleted,
  createPaymentInProgress,
  createPaymentFailed,
  createPaymentCompleted,
  createOrganizationCompleted,
  createOrganizationInProgress,
  createOrganizationFailed,
  fetchOrganizationMembersInProgress,
  fetchOrganizationMembersCompleted,
  fetchOrganizationMembersFailed,
  fetchOrganizationPendingMembersInProgress,
  fetchOrganizationPendingMembersFailed,
  fetchOrganizationPendingMembersCompleted,
  setPrePromo,
  setPreVoucher,
  removePrePromoCode,
  fetchOrganization,
  fetchOrganizationSettings,
  updateOrganizationSettings,
  createCreditCard,
  fetchOrganizationMembers,
  fetchOrganizationPendingMembers,
  fetchPaymentMethod,
  createOrganization,
  fetchDiscounts,
  applyDiscount,

  setSearchProgress,
  startUp,
  startUpCompleted,

  selectPrintOption,
  openPrintModal,
  closePrintModal,
  performPrintRequest,
  performPrintSuccess,

  disableNewVersion,
  sendEvent,
};

/**
|--------------------------------------------------
| Async Actions
|--------------------------------------------------
*/

export function fetchOrganization() {
  return (dispatch, getStore) => {
    if (getStore().app.isFetchingOrganization) {
      return;
    }

    dispatch(fetchOrganizationInProgress());
    ApiService.fetchOrganization().then(
      res => {
        dispatch(fetchOrganizationCompleted(res.data));
      },
      err => {
        const error = err.response;
        dispatch(fetchOrganizationFailed(extractError(error.data)));
      },
    );
  };
}

export function fetchOrganizationSettings(orgId) {
  return (dispatch, getStore) => {
    if (getStore().app.isFetchingOrganizationSettings) {
      return;
    }

    dispatch(fetchOrganizationSettingsInProgress());
    ApiService.fetchOrganizationSettings({ org_id: orgId }).then(
      res => {
        dispatch(fetchOrganizationSettingsCompleted(res.data));
      },
      err => {
        const error = err.response;
        dispatch(fetchOrganizationSettingsFailed(extractError(error.data)));
      },
    );
  };
}

export function updateOrganizationSettings(orgId, detailedLog, delete_logs = false) {
  return dispatch => {
    dispatch(updateOrganizationSettingsInProgress());
    return ApiService.updateOrganizationSettings({ org_id: orgId, detailed_log: detailedLog, delete_logs }).then(
      res => {
        dispatch(updateOrganizationSettingsCompleted(res.data, delete_logs));
      },
      err => {
        const error = err.response;
        dispatch(updateOrganizationSettingsFailed(extractError(error.data)));
      },
    );
  };
}

// TODO: Who use that? its sure a bug
export function createCreditCard(name, address, city, country, state, postalCode, number, cvv, month, year) {
  return dispatch => {
    dispatch(createPaymentInProgress());
    return ApiService.createCreditCard(name, address, city, country, state, postalCode, number, cvv, month, year).then(
      res => {
        dispatch(addNotification(MESSAGES.CREATE_PAYMENT_SUCCESS));
        dispatch(createPaymentCompleted(res.data));
      },
      err => {
        const error = err.response;
        dispatch(createPaymentFailed(extractError(error.data)));
      },
    );
  };
}

export function fetchOrganizationMembers() {
  return (dispatch, getStore) => {
    if (getStore().app.isFetchingMembers) {
      return;
    }

    dispatch(fetchOrganizationMembersInProgress());
    ApiService.fetchOrganizationMembers().then(
      res => {
        dispatch(fetchOrganizationMembersCompleted(res.data));
      },
      err => {
        const error = err.response;
        dispatch(fetchOrganizationMembersFailed(error.data));
      },
    );
  };
}

export function fetchOrganizationPendingMembers() {
  return (dispatch, getStore) => {
    dispatch(fetchOrganizationPendingMembersInProgress());
    ApiService.fetchOrganizationPendingMembers().then(
      res => {
        dispatch(fetchOrganizationPendingMembersCompleted(res.data));
      },
      error => {
        dispatch(fetchOrganizationPendingMembersFailed(error.data));
      },
    );
  };
}

export function fetchPaymentMethod() {
  return (dispatch, getStore) => {
    if (getStore().app.isFetchingPaymentMethod) {
      return;
    }

    dispatch(fetchPaymentMethodInProgress());
    ApiService.fetchPaymentMethod().then(
      res => {
        dispatch(fetchPaymentMethodCompleted(res.data));
      },
      err => {
        const error = err.response;
        dispatch(fetchPaymentMethodFailed(extractError(error.data)));
      },
    );
  };
}

export function createOrganization(
  name,
  invoiceEmail,
  website,
  phone,
  promoCode,
  address,
  city,
  country,
  state,
  postalCode,
  eventData = null,
) {
  return dispatch => {
    dispatch(createOrganizationInProgress());
    return ApiService.updateOrganization({
      name,
      website,
      phone,
      address,
      city,
      country,
      state,
      invoice_email: invoiceEmail,
      code: promoCode,
      postal_code: postalCode,
    }).then(
      res => {
        dispatch(addNotification(MESSAGES.CREATE_ORGANIZATION_SUCCESS));
        dispatch(createOrganizationCompleted(res.data, eventData));
      },
      err => {
        const body = err.response.data;
        const error =
          (body.address ? extractError(body.address) : extractError(body)) || MESSAGES.CREATE_ORGANIZATION_FAILED;
        dispatch(addNotification(error, 'error'));
        dispatch(createOrganizationFailed(error, body.address ? body : null, eventData));
      },
    );
  };
}

export function fetchDiscounts() {
  return dispatch => {
    dispatch(fetchDiscountsInProgress());
    ApiService.fetchDiscounts().then(
      res => {
        dispatch(fetchDiscountsCompleted(res.data));
      },
      err => {
        const error = err.response;
        dispatch(fetchDiscountsCompleted([]));
        dispatch(addNotification(MESSAGES.ERROR_FETCH_DISCOUNT, 'error'));
      },
    );
  };
}

export function applyDiscount(code) {
  return dispatch => {
    dispatch(applyDiscountInProgress());
    return new Promise((resolve, reject) => {
      ApiService.applyDiscount({ code }).then(
        res => {
          dispatch(applyDiscountCompleted(res.data));
          dispatch(addNotification(MESSAGES.APPLY_DISCOUNT_SUCCESS), 'success');
          resolve(MESSAGES.APPLY_DISCOUNT_SUCCESS);
        },
        err => {
          const error = err.response;
          dispatch(applyDiscountFailed(extractError(error.data)));
          dispatch(addNotification(MESSAGES.APPLY_DISCOUNT_FAILED, 'error'));
          reject(MESSAGES.APPLY_DISCOUNT_FAILED);
        },
      );
    });
  };
}
